module.exports = __webpack_public_path__ + "static/img/blurred-background.4e4bc24.jpg";